import { useEffect, useState } from "react";
import axios from "axios";

const useDoctorOptions = (activeOnly = true, clinicName = "") => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDoctors = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("user_id");
        const params = new URLSearchParams({ simple: "true" });
        if (activeOnly) params.append("status", "Active");
        if (clinicName) params.append("clinic", clinicName);

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/users/get-doctors?${params.toString()}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (response.data?.success) {
          setDoctors(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching doctor options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDoctors();
  }, [activeOnly, clinicName]);

  return { doctors, loading };
};

export default useDoctorOptions;
